import(/* webpackMode: "eager", webpackExports: ["VacanciesContent"] */ "/var/www/azia_frontv2_green/src/app/vacancies/vacancies-content.tsx");
